import {
  IconButton,
  InfoSmIcon,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@crono-one/design-system';
import ConditionalForkIcon from 'crono-fe-common/icons/Condition-fork-icon';
import { cn } from 'utils/style-utils';
import DelayButton from '../delayButton';

const CONDITIONAL_TOOLTIP_COPY =
  'Checks if your LinkedIn invitation is accepted within the days you set. If it is, the sequence continues as planned. If not, it follows the alternative path you choose.';

interface ConditionalFlowButtonProps {
  id?: string;
  delay: number;
  decreaseDelay?: () => void;
  increaseDelay?: () => void;
  disabledText?: string;
  previewOnly?: boolean;
}

const ConditionalFlowButton = ({
  id,
  delay,
  decreaseDelay = () => {},
  increaseDelay = () => {},
  disabledText,
  previewOnly = false,
}: ConditionalFlowButtonProps) => {
  const conditionRow = (
    <div className="flex items-center gap-1.5">
      <ConditionalForkIcon
        color="currentColor"
        className={cn('text-sky-700', {
          'text-neutral-500': !!disabledText,
        })}
      />

      <span
        className={cn('text-xs font-medium text-sky-700', {
          'text-neutral-500': !!disabledText,
        })}
      >
        Check if LinkedIn invitation is accepted
      </span>

      <span
        className={cn('text-xs font-medium text-gray-900', {
          'text-neutral-500': !!disabledText,
        })}
      >
        Within
      </span>

      <DelayButton
        delay={delay}
        decreaseDelay={decreaseDelay}
        increaseDelay={increaseDelay}
        tooltipTitle={''}
        disabled={!!disabledText || previewOnly}
      />
    </div>
  );

  return (
    <div id={id} className="w-fit">
      <div
        className={cn(
          'flex h-10.5 cursor-auto items-center gap-1.5 rounded-lg border border-sky-700 bg-sky-100 px-3',
          {
            'border-transparent bg-neutral-100': !!disabledText,
          },
        )}
      >
        {disabledText ? (
          <Tooltip>
            <TooltipTrigger asChild>{conditionRow}</TooltipTrigger>

            <TooltipContent side="top">{disabledText}</TooltipContent>
          </Tooltip>
        ) : (
          conditionRow
        )}

        <Tooltip>
          <TooltipTrigger asChild>
            <IconButton
              icon={InfoSmIcon}
              label="What this condition does"
              variant="text"
              tone="gray"
              size="sm"
            />
          </TooltipTrigger>

          <TooltipContent side="top">{CONDITIONAL_TOOLTIP_COPY}</TooltipContent>
        </Tooltip>
      </div>
    </div>
  );
};

export default ConditionalFlowButton;
